import { useState } from "react";
import { rankingMovies, rankingSeries, rankingTags, type RankItem } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function RankingSection() {
  const [tab, setTab] = useState("movie");
  const list: RankItem[] = tab === "movie" ? rankingMovies : rankingSeries;
  const top3 = list.slice(0, 3);
  const rest = list.slice(3);

  return (
    <section id="ranking" className="scroll-mt-24 bg-secondary-900 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="TRENDING NOW"
            tone="dark"
            title="追剧榜单：电影榜与电视剧榜实时关注度"
            desc="榜单按站内片库的观众关注度综合排列，并标注上升、下降、新上榜等趋势参考，帮你快速判断最近大家都在看什么。"
          />
          <div className="flex rounded-full bg-background-50/10 p-1" role="tablist" aria-label="榜单切换">
            {rankingTags.map((item) => {
              const isActive = tab === item.id;
              return (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setTab(item.id)}
                  className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary-500 text-foreground-950" : "text-background-200 hover:text-background-50"
                  }`}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {top3.map((item) => (
            <article
              key={item.title}
              className="relative overflow-hidden rounded-lg border border-background-50/10 bg-background-50/5 p-5"
            >
              <span className="font-heading text-5xl font-black text-primary-500/40">{item.rank}</span>
              <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{item.title}</h3>
              <p className="mt-1 text-xs text-background-200">{item.meta}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="flex items-center gap-1 font-heading text-xl font-bold text-primary-300">
                  <i className="ri-star-fill text-sm"></i>
                  {item.score}
                </span>
                <span className="rounded-full bg-background-50/10 px-2.5 py-0.5 font-label text-xs text-background-100">
                  {item.trend}
                </span>
              </div>
            </article>
          ))}
        </div>

        <ul className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
          {rest.map((item) => (
            <li
              key={item.title}
              className="flex items-center gap-4 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3"
            >
              <span className="w-6 shrink-0 text-center font-heading text-lg font-bold text-background-200">
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-heading text-sm font-bold text-background-50">{item.title}</p>
                <p className="truncate text-xs text-background-300">{item.meta}</p>
              </div>
              <span className="shrink-0 font-heading text-base font-bold text-primary-300">{item.score}</span>
              <span className="hidden shrink-0 text-xs text-background-300 sm:block">{item.trend}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}